<template>
  <div class="card mgb-100px">
    <header class="header-card">
      <p>{{ $t('ajoutEditContrat.echeancier.title') }}</p>
    </header>
    <div class="card-content">
      <div v-if="!canGenerate" class="mgb-20px">
        <app-information-msg-component
          :title="'ajoutEditContrat.echeancier.info.noGenerate'"
          :libelleList="[{isLink: false, libelle: $t('ajoutEditContrat.echeancier.info.message')}]"
          :canClose="false"/>
      </div>
      <div v-if="getListeEcheanceOutsideRange.length > 0" class="mgb-20px">
        <app-information-msg-component
          title="ajoutEditContrat.echeancier.info.echeanceOutsideTitle"
          :libelleList="getListeEcheanceOutsideRange"
          :canClose="false"/>
      </div>
      <div v-if="getListeMessageBlocage.length > 0" class="mgb-20px">
        <app-information-msg-component
          title="detailContrat.blocagePaiement"
          :libelleList="getListeMessageBlocage"
          :canClose="false"/>
      </div>
      <div>
        <qd-message
          v-if="getEcheanceIndexeeModifiees.length > 0"
          type="is-warning">
            <p>{{$t('ajoutEditContrat.indexation.echeanceIndexee')}}</p>
            <p class="pdl-4" v-for="(e, i) in getEcheanceIndexeeModifiees" :key="i">
              {{$t(
                'ajoutEditContrat.indexation.echeanceIndexeeDate',
                {
                  tier: e.tiers.nomCommercial,
                  debut: func.formatDate(e.debutPeriode),
                  fin: func.formatDate(e.finPeriode),
                }
              )
              }}
            </p>
        </qd-message>
        <div class="columns">
          <div class="column is-8 is-9-fullhd">
            <div class="columns is-multiline">
              <div class="column is-narrow" v-for="(bailleur, index) in bailleurList"
                  :key="index">
                <qd-checkbox v-model="bailleur.mustAppearInEcheanceList">
                  {{ bailleur.libelle }}
                </qd-checkbox>
              </div>
            </div>
          </div>
          <div class="column is-4 is-3-fullhd has-text-right">
            <qd-checkbox v-model="masquerEcheancePaye">
              {{ $t('ajoutEditContrat.actions.masquerEcheancePaye') }}
            </qd-checkbox>
          </div>
        </div>

        <div class="card transparentCardNoBorder">
          <div class="card-content pdb-5px pdt-0">
            <div class="columns">
              <div class="column is-narrow">
                <b-icon icon="chevron-right"
                        type="is-default" class="is-invisible"></b-icon>
              </div>
              <div class="column is-3 has-text-link has-text-weight-bold has-text-link">
                {{ $t('ajoutEditContrat.echeancier.periodeEcheance')}}
              </div>
              <div class="column is-2 has-text-link has-text-weight-bold">
                {{ $t('ajoutEditContrat.echeancier.montantHt')}}
              </div>
              <div class="column is-3 has-text-link has-text-weight-bold">
                {{ $t('ajoutEditContrat.echeancier.echeancierlibelle')}}
              </div>
              <div class="column is-3 has-text-link has-text-weight-bold">
                {{ $t('ajoutEditContrat.echeancier.blocagePaiement')}}
              </div>
            </div>
          </div>
        </div>

        <div class="card has-background-background pdb-10px">
          <div class="card-content overflow-x-auto">
            <div class="columns">
              <div class="column is-narrow is-cursor-pointer"
                  @click="afficherEcheancier = !afficherEcheancier">
                <b-icon :icon="afficherEcheancier ? 'chevron-down' : 'chevron-right'"
                        type="is-default"></b-icon>
              </div>
              <div class="column is-3 has-text-link">
                <span class="has-text-weight-bold"
                      v-if="getSmallestDateDebut && getHeightestDateFin">
                  {{ $t('ajoutEditContrat.echeancier.dateEcheancier',
                  { dateDebut: getSmallestDateDebut,
                    dateFin: getHeightestDateFin }) }}
                </span>
              </div>
              <div class="column is-2">
                {{ getTotalGeneral('montantHt') | formatDevise}}
              </div>
              <div class="column is-3 pdv-0 mgl-0">
                <qd-button class="button" @click="popUpGenerationEcheancier = true"
                          :disabled="!canGenerate"
                          :class="{'is-primary': contrat.echeancier.length === 0}">
                  {{ $t('ajoutEditContrat.echeancier.genererEcheancier')}}
                </qd-button>
              </div>
              <div class="column is-3 pdb-0 pdt-0">
                <div class="columns">
                  <qd-switch v-model="contrat.blocageReglement"
                            @input="updateMotifBlocage"
                            class="column is-narrow pdr-0">
                  </qd-switch>
                  <parametre-autocomplete
                      v-model="contrat.motifBlocageId"
                      :target="constantes.PARAMETRES_KEYS.motifBlocage"
                      :disabled="!contrat.blocageReglement"
                      class="column pdl-0 px-0"
                      expanded
                   />
                </div>
              </div>
              <div class="column is-narrow mgl-30px">
                <verticalDotsDropdown
                    :dropdownItems="firstDropdownItems"/>
              </div>
            </div>
            <div v-if="contrat.echeancier.length > 0 && afficherEcheancier">
              <div class="columns">
                <div class="column is-narrow">
                  <selecteur-action
                    @handleAction="handleAction"
                    :options='actions'
                    :placeholder='$t("general.placeHolder.groupedAction")'
                    :titleButton="'general.button.apply'"
                    :elementsSelectionnes="getAllEcheanceSelected().length > 0"
                  ></selecteur-action>
                </div>
              </div>
              <div class="mgb-300px">
              <table class="VueTables__table table is-bordered is-striped is-fullwidth">
                  <thead>
                  <tr>
                    <th @click="selectAll" class="is-cursor-pointer">
                      <b-icon :icon="iconSelectTotal"></b-icon></th>
                    <th>{{ $t('ajoutEditContrat.echeancier.tabEcheance.bailleur') }}</th>
                    <th>{{ $t('ajoutEditContrat.echeancier.tabEcheance.produit') }}</th>
                    <th>
                      {{ $t('ajoutEditContrat.echeancier.tabEcheance.dateEcheance') }}
                      <a @click="updateSort('dateEcheance', 'date')"
                        class="is-pulled-right">
                        <b-icon :icon="getIconSort('dateEcheance')"
                                size="is-small">
                        </b-icon>
                      </a>
                    </th>
                    <th>{{ $t('ajoutEditContrat.echeancier.tabEcheance.tauxTva') }}</th>
                    <th>
                      {{ $t('ajoutEditContrat.echeancier.tabEcheance.montantHt') }}
                      <a @click="updateSort('montantHt', 'montant')"
                        class="is-pulled-right">
                        <b-icon :icon="getIconSort('montantHt')"
                                size="is-small">
                        </b-icon>
                      </a>
                    </th>
                    <th>
                      {{ $t('ajoutEditContrat.echeancier.tabEcheance.montantTtc') }}
                      <a @click="updateSort('montantTtc', 'montant')"
                        class="is-pulled-right">
                        <b-icon :icon="getIconSort('montantTtc')"
                                size="is-small">
                        </b-icon>
                      </a>
                    </th>
                    <th>{{ $t('ajoutEditContrat.echeancier.tabEcheance.modePaiement') }}</th>
                    <th>
                      {{ $t('ajoutEditContrat.echeancier.tabEcheance.debut') }}
                      <a @click="updateSort('debutPeriode', 'date')"
                        class="is-pulled-right">
                        <b-icon :icon="getIconSort('debutPeriode')"
                                size="is-small">
                        </b-icon>
                      </a>
                    </th>
                    <th>
                      {{ $t('ajoutEditContrat.echeancier.tabEcheance.fin') }}
                      <a @click="updateSort('finPeriode', 'date')"
                        class="is-pulled-right">
                        <b-icon :icon="getIconSort('finPeriode')"
                                size="is-small">
                        </b-icon>
                      </a>
                    </th>
                    <th>{{ $t('ajoutEditContrat.echeancier.tabEcheance.aRapprocher') }}</th>
                    <th>
                      {{ $t('ajoutEditContrat.echeancier.tabEcheance.montantFactureAchatTtc') }}
                      <a @click="updateSort('montantAppele', 'montant')"
                        class="is-pulled-right">
                        <b-icon :icon="getIconSort('montantAppele')"
                                size="is-small">
                        </b-icon>
                      </a>
                    </th>
                    <th>
                      {{ $t('ajoutEditContrat.echeancier.tabEcheance.montantPaye') }}
                      <a @click="updateSort('montantEcheancierPaye', 'montant')"
                        class="is-pulled-right">
                        <b-icon :icon="getIconSort('montantEcheancierPaye')"
                                size="is-small">
                        </b-icon>
                      </a>
                    </th>
                    <th>{{ $t('ajoutEditContrat.echeancier.tabEcheance.paye') }}</th>
                    <th></th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                  <template v-for="bailleur in bailleurList">
                    <tr v-for="ligne in
                getLignesWithTiersId(bailleur.tiersId, bailleur.mustAppearInEcheanceList)"
                        :key="ligne.key">
                      <td class="pd-3px has-text-centered is-vertical">
                        <qd-checkbox v-model="ligne.selected"
                                    :disabled="ligne.etat && !isModifiable(ligne.etat)"
                                    class="mgt-10px pdl-5px"></qd-checkbox>
                      </td>
                      <td class="pd-3px">
                        <b-select v-model='ligne.tiersId' expanded
                                  @input="updateLibelle(ligne, bailleurList)"
                                  :disabled="ligne.etat && !isModifiable(ligne.etat)">
                          <option v-for="unitBailleur in bailleurList" :value="unitBailleur.tiersId"
                                  :key="unitBailleur.tiersId">
                            {{ unitBailleur.libelle }}
                          </option>
                        </b-select>
                      </td>
                      <td>
                        <p v-if="ligne.etat && !isModifiable(ligne.etat)"
                          class="has-text-centered">
                          {{ getProduitLocationEtDiversLibelle(ligne) }}
                        </p>
                        <b-autocomplete v-else
                          :value="getProduitLocationEtDiversLibelle(ligne)"
                          :data="produitsAchat"
                          :loading="false"
                          :open-on-focus="true"
                          @select="setProduitAchat($event, ligne)"
                          @input="getProduitAchat"
                          field="libelle"
                          icon="magnify">
                          <template slot-scope="props">
                            {{ props.option.libelle }}
                          </template>
                          <template slot="empty">
                            <div>
                              {{$t('general.autocomplete.noRslt')}}
                            </div>
                          </template>
                        </b-autocomplete>
                      </td>
                      <td class="pd-3px colonne-responsive colonne-responsive--date">
                        <b-datepicker show-week-number icon="calendar-today"
                                      :disabled="ligne.etat &&!isModifiable(ligne.etat)"
                                      :editable="true" v-model="ligne.dateEcheance"
                                      position="is-bottom-right"
                                      :nearby-selectable-month-days="true"/>
                      </td>
                      <td class="pd-3px">
                        <b-select v-model='ligne.pourcentageTva' expanded
                                  @input="updateMontantTTc(ligne)"
                                  :disabled="ligne.etat && !isModifiable(ligne.etat)">
                            <option v-for="tva in regimesTva"
                                  :key="tva.tauxTva"
                                  :value="tva.tauxTva">
                            {{ tva.tauxTva | formatPercent }}
                          </option>
                        </b-select>
                      </td>
                      <td class="pd-3px">
                        <input-currency :peutEtreNegatif="true"
                                        v-model="ligne.montantHt " isNumber="true"
                                        @input="updateMontantTTc(ligne)"
                                        :disabled="ligne.etat &&!isModifiable(ligne.etat)">
                        </input-currency>
                      </td>
                      <td class="pd-3px">
                        <input-currency :peutEtreNegatif="true"
                                        v-model="ligne.montantTtc " isNumber="true" disabled>
                        </input-currency>
                      </td>
                      <td class="pd-3px">
                        <b-select v-model='ligne.modeReglementId' expanded
                                  :disabled="ligne.etat && !isModifiable(ligne.etat)">
                          <option
                            v-for="modeReglement in modesReglement"
                            :value="modeReglement.id"
                            :key="modeReglement.id">
                            {{ modeReglement.libelle }}
                          </option>
                        </b-select>
                      </td>
                      <td class="pd-3px colonne-responsive colonne-responsive--date">
                        <b-datepicker show-week-number icon="calendar-today" :editable="true"
                                      :disabled="ligne.etat &&!isModifiable(ligne.etat)"
                                      v-model="ligne.debutPeriode" position="is-bottom-left"
                                      :nearby-selectable-month-days="true" expanded/>
                      </td>
                      <td class="pd-3px colonne-responsive colonne-responsive--date">
                        <b-datepicker show-week-number icon="calendar-today"
                                      :editable="true"
                                      :disabled="ligne.etat &&!isModifiable(ligne.etat)"
                                      v-model="ligne.finPeriode" position="is-bottom-left"
                                      :nearby-selectable-month-days="true"/>
                      </td>
                      <td class="has-text-centered">
                        <qd-checkbox v-model="ligne.aRapprocher" class="mgt-5px"
                                    :disabled="ligne.etat &&!isModifiable(ligne.etat)">
                        </qd-checkbox>
                      </td>
                      <td class="pd-3px">
                        <div class="has-text-link has-text-right pd-5px">
                          <b-tooltip type='is-white' position="is-left"
                            :active="ligne.factures
                            && ligne.factures.length >0">
                            <template v-slot:content>
                              <echeanceFacturesTable :commande="ligne" />
                            </template>
                          <router-link-blank
                            v-if="ligne.factures && ligne.factures.length > 0"
                            :to="{ name: getRouteNameFacture(ligne),
                              params: getParamsFacture(ligne) }"
                            :message="ligne.montantAppele | formatDevise">
                          </router-link-blank>
                          <span v-else>
                            {{ ligne.montantAppele | formatDevise }}
                          </span>
                          </b-tooltip>
                        </div>
                      </td>
                      <td class="pd-3px">
                        <div class="has-text-link has-text-right pd-5px">
                          <b-tooltip type='is-white' position="is-left"
                            :active="ligne.factures && ligne.factures.length >0">
                            <template v-slot:content>
                              <echeancePaiementsTable :commande="ligne" showTypePiece/>
                            </template>
                            <span v-if="getIdsLotPaiement(ligne).length === 0">
                              {{ colPayee(ligne) }}
                            </span>
                            <router-link-blank
                              v-else-if="getRoutePiece(ligne)"
                              v-bind="getRoutePiece(ligne)">
                            </router-link-blank>
                            <a v-else
                              @click="openPopupPaiement(ligne)"
                              class="lien">
                              {{ getMontantPaye(ligne) | formatDevise }}
                            </a>
                          </b-tooltip>
                        </div>
                      </td>
                      <td class="pd-3px has-text-centered">
                        <div class="has-text-link has-text-centered pd-5px">
                          <qd-checkbox class="mgl-10px" disabled
                                      :value="isPaid(ligne)">
                          </qd-checkbox>
                        </div>
                      </td>
                      <td class="has-text-centered">
                        <verticalDotsDropdown
                          :dropdownItems="secondDropdownItems(ligne)"/>
                      </td>
                      <td class="pd-5px has-text-centered vertical-alignment is-cursor-pointer"
                          @click="setCommentaireList(ligne)"
                          v-if="(ligne.commentaires && ligne.commentaires.length > 0)
                                || ligne.commentaire">
                        <b-icon type="is-primary" icon="information" size="small">
                        </b-icon>
                      </td>
                      <td v-else></td>
                    </tr>
                    <tr :key="bailleur.tiersId" class="has-text-link"
                        v-if="(getLignesWithTiersId(bailleur.tiersId,
                    bailleur.mustAppearInEcheanceList)).length > 0">
                      <td colspan="5">
                        <div class="has-text-link has-text-weight-bold">
                          {{ $t('ajoutEditContrat.echeancier.tabEcheance.totalBailleur',
                          { bailleur: getLibelleTier(bailleur.tiersId) }) }}
                        </div>
                      </td>
                      <td class="pd-3px">
                        <div class="has-text-link has-text-weight-bold has-text-right pd-5px">
                          {{ getMontantByTiers(bailleur.tiersId, 'montantHt') | formatDevise }}
                        </div>
                      </td>
                      <td class="pd-3px">
                        <div class="has-text-link has-text-weight-bold has-text-right pd-5px">
                          {{ getMontantByTiers(bailleur.tiersId, 'montantTtc') | formatDevise }}
                        </div>
                      </td>
                      <td colspan="4"></td>
                      <td class="pd-3px">
                        <div class="has-text-link has-text-weight-bold has-text-right pd-5px">
                          {{ getMontantByTiers(bailleur.tiersId, 'montantAppele')
                          | formatDevise }}
                        </div>
                      </td>
                      <td class="pd-3px">
                        <div class="has-text-link has-text-weight-bold has-text-right pd-5px">
                          {{ getMontantByTiers(bailleur.tiersId,
                           'montantEcheancierPaye') | formatDevise }}
                        </div>
                      </td>
                      <td colspan="3"></td>
                    </tr>
                  </template>
                  <tr class="has-text-link" v-if="hasMultipleBailleurInList > 1">
                    <td colspan="5">
                      <div class="has-text-link has-text-weight-bold pd-3px">
                        {{ $t('ajoutEditContrat.echeancier.tabEcheance.totalBailleur',
                        { bailleur: '' }) }}
                      </div>
                    </td>
                    <td class="pd-3px">
                      <div class="has-text-link has-text-weight-bold has-text-right pd-5px">
                        {{ getTotalGeneral('montantHt') | formatDevise }}
                      </div>
                    </td>
                    <td class="pd-3px">
                      <div class="has-text-link has-text-weight-bold has-text-right pd-5px">
                        {{ getTotalGeneral('montantTtc') | formatDevise }}
                      </div>
                    </td>
                    <td colspan="4"></td>
                    <td class="pd-3px">
                      <div class="has-text-link has-text-weight-bold has-text-right pd-5px">
                        {{ getTotalGeneral('montantAppele') | formatDevise }}
                      </div>
                    </td>
                    <td class="pd-3px">
                      <div class="has-text-link has-text-weight-bold has-text-right pd-5px">
                        {{ getTotalGeneral('montantEcheancierPaye') | formatDevise }}
                      </div>
                    </td>
                    <td colspan="3"></td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="popUpGenerationEcheancier" has-modal-card class="modal">
      <creation-echeancier :contrat="contrat" :echeancier="echeancier"
                           @echeancierGenerer="updateEcheancier"></creation-echeancier>
    </b-modal>
    <b-modal v-model="viewDetailProduits" has-modal-card class="modal modal-width-1250px">
      <detail-produits-liste
        :dateDebut="contrat.dateDebutSignature"
        :dateFin="contrat.dateFinSignature"
        :produits="echeance.listeProduits"
        :echeance="echeance"
      ></detail-produits-liste>
    </b-modal>
    <b-modal v-model="popUpEditCommentaire" has-modal-card class="modal" :width="500">
      <edition-commentaire :echeance="echeanceToUpdateCommentaire"></edition-commentaire>
    </b-modal>
    <b-modal v-model="popUpInformationCommentaire" has-modal-card class="modal" :width="500">
      <information-commentaires :echeance="echeanceInfoCommentaire"></information-commentaires>
    </b-modal>
    <b-modal v-model="popUpAddTiers" has-modal-card class="modal">
      <search-new-bailleur :tiersIdToNotInclude="bailleurList"
                           @newTiers="addBailleur"></search-new-bailleur>
    </b-modal>
    <b-modal
      v-model="popUpAddEcheancierManuel"
      has-modal-card
      class="modal"
      :width="500">
      <ajout-echeancier-manuel
        :bailleurs="bailleurList"
        @bailleurSelected="addEcheancierManuel"></ajout-echeancier-manuel>
    </b-modal>
    <b-modal
      v-model="isPopupPaiment"
      @close="hidePopupPaiement()"
      class="modal"
      has-modal-card>
        <popup-paiement :ligne="ligneEcheancierSelectionnee" />
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import creationEcheancier from '@/components/baux/contrat/componentEdition/p_creationEcheancier';
import formatDate from '@/services/general/formatDate';
import inputCurrency from '@/components/general/inputCurrency';
import {
  ECHEANCE_ENREGISTRER,
  ECHEANCE_BROUILLON,
  ECHEANCE_FACTURE,
  ECHEANCE_FACTURE_PARTIELLEMENT,
} from '@/configuration/baux/contrat/echeancier/echeancier';
import genererGuid from '@/services/general/genererGuid';
import sortEcheance from '@/services/baux/contrat/sortEcheance';
import { PARAMETRES_KEYS, PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { AUCUN } from '@/configuration/parametrage/modeReglementConf';
import AppInformationMsgComponent from '@/components/general/informationMsgComponent';
import echeanceFacturesTable from '@/components/baux/contrat/echeancesContratTooltipTable/echeanceFacturesTable';
import echeancePaiementsTable from '@/components/baux/contrat/echeancesContratTooltipTable/echeancePaiementsTable';
import messageSucces from '@/services/general/messageSucces';
import detailProduitsListe from '@/components/gabed/contrat/commun/p_detailProduitList';
import searchNewBailleur from '@/components/baux/contrat/componentEdition/p_searchNewBailleur';
import selecteurAction from '@/components/general/selecteurAction';
import { ACTION_DELETE } from '@/configuration/general/actionsConf';
import informationCommentaires from '@/components/baux/contrat/componentEdition/p_informationCommentaires';
import editionCommentaire from '@/components/baux/contrat/componentEdition/p_editionCommentaireEcheancierContrat';
import ajoutEcheancierManuel from '@/components/baux/contrat/componentEdition/p_ajoutEcheancierManuel';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import genererEcheancierManuelContrat from '@/services/baux/contrat/genererEcheancierManuel';
import verticalDotsDropdown from '@/components/general/button/verticalDotsDropdown';
import isEqual from 'lodash/isEqual';
import { getAll as getAllLocation } from '@/api/produit/produitLocation';
import { getAll as getAllDivers } from '@/api/produit/produitDivers';
import { SENS_ACHAT } from '@/configuration/devisConf';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import { TYPE_OD } from '@/configuration/compta/ecritureConf';
import { CHARGE } from '@/configuration/mouvementClient/mouvementClientConf';
import { formatDevise } from '@/services/general/filters/formatDevise';
import popupPaiement from '@/components/baux/contrat/componentDetail/popUpPaiement';
import parametreAutocomplete from '@/components/general/autocomplete/parametreAutocomplete';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'BauxContratEditEcheancier',
  props: {
    contrat: { type: Object, required: true },
    echeancier: { type: Object, required: true },
    lockEcheancier: { type: Array, required: false, default: () => [] },
  },
  data() {
    return {
      popUpGenerationEcheancier: false,
      afficherEcheancier: false,
      bailleurList: [],
      echeance: {},
      viewDetailProduits: false,
      popUpAddTiers: false,
      popUpEditCommentaire: false,
      echeanceKeySave: null,
      popUpInformationCommentaire: false,
      echeanceToUpdateCommentaire: {},
      echeanceInfoCommentaire: {},
      actions: [
        { action: ACTION_DELETE, translation: 'ajoutEditContrat.actions.remove' },
      ],
      masquerEcheancePaye: false,
      sort: {
        name: null,
        sens: 'DESC',
        type: null,
      },
      func: {
        formatDate,
      },
      popUpAddEcheancierManuel: false,
      produitsAchat: [],
      allProduitsAchat: [],
      produitAchatLocDefault: null,
      isPopupPaiment: false,
      ligneEcheancierSelectionnee: null,
      constantes: {
        PARAMETRES_KEYS,
      },
    };
  },
  components: {
    creationEcheancier,
    inputCurrency,
    AppInformationMsgComponent,
    detailProduitsListe,
    searchNewBailleur,
    selecteurAction,
    informationCommentaires,
    editionCommentaire,
    routerLinkBlank,
    ajoutEcheancierManuel,
    verticalDotsDropdown,
    echeanceFacturesTable,
    echeancePaiementsTable,
    popupPaiement,
    parametreAutocomplete,
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    isClearedWithoutBill(echeance) {
      return (echeance.etat === ECHEANCE_FACTURE
        || echeance.etat === ECHEANCE_FACTURE_PARTIELLEMENT)
        && !(echeance.factures && echeance.factures.length > 0);
    },
    colPayee(echeance) {
      if (this.isClearedWithoutBill(echeance)) {
        return '';
      }
      return formatDevise(echeance.montantPaye);
    },
    getIdsLotPaiement(ligne) {
      if (!ligne.factures) return [];
      let ids = [];
      ligne.factures.forEach((facture) => {
        ids = ids.concat(facture.paiementsIds);
      });
      return ids;
    },
    getMontantPaye(ligne) {
      return ligne.aRapprocher
        ? ligne.montantEcheancierPaye : ligne.montantPaye;
    },
    getRoutePiece(ligne) {
      const ids = this.getIdsLotPaiement(ligne);
      const typePieces = [...new Set(ligne.factures.flatMap(f => f.listePaiement
        .map(p => p.typeDePiece)))];
      const message = ligne.aRapprocher
        ? formatDevise(ligne.montantEcheancierPaye) : formatDevise(ligne.montantPaye);

      if (typePieces.length !== 1) return null;

      const type = typePieces[0];
      const isMultiple = ids.length > 1;
      const idParam = isMultiple ? JSON.stringify(ids) : ids[0];

      if (type === TYPE_OD) {
        return {
          to: {
            name: isMultiple ? 'l.comptabilite.operation_diverse' : 'c.comptabilite.operation_diverse',
            params: { [isMultiple ? 'idsOd' : 'id']: idParam },
          },
          message,
        };
      }

      if (type === CHARGE) {
        return {
          to: {
            // eslint-disable-next-line no-nested-ternary
            name: isMultiple
              ? (ligne.aRapprocher ? 'l.baux.facture_achat-bailleur-idsFactures' : 'l.baux.facture_achat-idsFactures')
              : 'c.baux.facture_achat',
            params: { [isMultiple ? 'idsFactures' : 'id']: idParam },
          },
          message,
        };
      }

      return {
        to: {
          name: isMultiple ? 'l.baux.lot_paiement' : 'c.baux.lot_paiement',
          params: { [isMultiple ? 'idsLots' : 'id']: idParam },
        },
        message,
      };
    },
    openPopupPaiement(ligne) {
      this.ligneEcheancierSelectionnee = ligne;
      this.isPopupPaiment = true;
    },
    hidePopupPaiement() {
      this.isPopupPaiment = false;
      this.ligneEcheancierSelectionnee = null;
    },
    getRouteNameFacture(ligne) {
      if (ligne.factures.length === 1) return 'c.baux.facture_achat';
      if (ligne.aRapprocher) return 'l.baux.facture_achat-bailleur';
      return 'l.baux.facture_achat';
    },
    getParamsFacture(ligne) {
      if (ligne.factures.length === 1) return { id: ligne.factures[0].id };
      return { idDevisCommande: ligne.devisCommandeId };
    },
    updateSort(sort, typeSort) {
      if (sort !== this.sort.name) {
        this.sort = {
          name: sort,
          sens: 'DESC',
          typeSort: typeSort,
        };
        return;
      }
      this.sort.sens = this.sort.sens === 'DESC' ? 'ACS' : 'DESC';
    },
    getIconSort(sort) {
      if (sort !== this.sort.name) return 'sort';
      return this.sort.sens === 'DESC' ? 'chevron-up' : 'chevron-down';
    },
    updateMotifBlocage(blocagePaiement) {
      if (!blocagePaiement) this.contrat.motifBlocageId = null;
    },
    addBailleur(newBaileur) {
      const echeanceToEdit = this.contrat.echeancier.find((echeance) => {
        return echeance.key === this.echeanceKeySave;
      });
      echeanceToEdit.tiers.nomCommercial = newBaileur.libelle;
      echeanceToEdit.tiersId = newBaileur.tiersId;
      this.bailleurList.push(newBaileur);
      this.bailleurList = cloneDeep(this.getBailleur);
    },
    setCommentaireList(echeance) {
      this.echeanceInfoCommentaire = echeance;
      this.popUpInformationCommentaire = true;
    },
    handleAction(action) {
      switch (action) {
        case ACTION_DELETE:
          this.deleteMultipleEcheance();
          break;
        default:
          break;
      }
    },
    deleteMultipleEcheance() {
      this.contrat.echeancier = this.contrat.echeancier.filter((echeance) => {
        return echeance.selected === false;
      });
      messageSucces(this.$i18n.t('ajoutEditContrat.echeancier.tabEcheance.message.sucessDeleteEcheances'));
      this.bailleurList = cloneDeep(this.getBailleur);
    },
    updateMontantTTc(echeance) {
      echeance.montantTtc = echeance.montantHt + (echeance.montantHt * (
        echeance.pourcentageTva / 100
      ));
    },
    editCommentaire(echeance) {
      this.echeanceToUpdateCommentaire = echeance;
      this.popUpEditCommentaire = true;
    },
    addTiers(key) {
      this.popUpAddTiers = true;
      this.echeanceKeySave = key;
    },
    setDetailProduits(echeance) {
      this.echeance = cloneDeep(echeance);
      if (this.echeance.listeProduits.length === 0) {
        this.echeance.listeProduits = this.contrat.contratsProduits;
      }
      this.viewDetailProduits = true;
    },
    isModifiable(etat) {
      return (etat === ECHEANCE_ENREGISTRER || etat === ECHEANCE_BROUILLON);
    },
    isPaid(echeance) {
      return Math.abs(echeance.montantPaye) >= Math.abs(echeance.montantHt)
        && Math.abs(echeance.montantHt) > 0;
    },
    deleteEcheance(key) {
      const index = this.contrat.echeancier.findIndex((echeancier) => {
        return echeancier.key === key;
      });
      this.contrat.echeancier.splice(index, 1);
      this.bailleurList = cloneDeep(this.getBailleur);
      messageSucces(this.$i18n.t('ajoutEditContrat.echeancier.tabEcheance.message.sucessDeleteEcheance'));
    },
    updateLibelle(ligne, bailleurList) {
      const bailleurReference = bailleurList.find((bailleur) => {
        return bailleur.tiersId === ligne.tiersId;
      });
      if (bailleurReference) {
        ligne.tiers.nomCommercial = bailleurReference.libelle;
      }
      this.bailleurList = cloneDeep(this.getBailleur);
    },
    getDate(date) {
      return formatDate(date);
    },
    getLibelleTier(tiersId) {
      if (!tiersId) return '';
      return this.bailleurList.find((bailleur) => {
        return bailleur.tiersId === tiersId;
      }).libelle;
    },
    getTotalGeneral(key) {
      if (this.contrat.echeancier.length === 0) return 0;
      return this.contrat.echeancier
        .map((echeance) => {
          if (key === 'montantEcheancierPaye') {
            return echeance.aRapprocher
              ? echeance.montantEcheancierPaye : echeance.montantPaye;
          }
          return echeance[key] || 0;
        })
        .reduce((accumulator, currentValue) => { return accumulator + currentValue; });
    },
    getNombreProduits(ligne) {
      if (ligne.listeProduits.length > 0) return ligne.listeProduits.length;
      return this.contrat.contratsProduits.length;
    },
    getMontantByTiers(tiersId, key) {
      if (this.contrat.echeancier
        .filter((echeance) => { return echeance.tiersId === tiersId; }).length === 0) return 0;
      return this.contrat.echeancier
        .filter((echeance) => { return echeance.tiersId === tiersId; })
        .map((echeance) => {
          if (key === 'montantEcheancierPaye') {
            return echeance.aRapprocher
              ? echeance.montantEcheancierPaye : echeance.montantPaye;
          }
          return echeance[key] || 0;
        })
        .reduce((accumulator, currentValue) => { return accumulator + currentValue; });
    },
    getLignesWithTiersId(tiersId, mustAppearInEcheanceList) {
      const ligne = this.contrat.echeancier.filter((ligne) => {
        return (ligne.tiersId === tiersId && mustAppearInEcheanceList
          && (!this.masquerEcheancePaye
            || (this.masquerEcheancePaye
              && (ligne.montantHt !== ligne.montantPaye || ligne.montantHt === 0))));
      });
      sortEcheance(ligne, this.sort);
      return ligne;
    },
    selectAll() {
      const select = !this.allEcheanceSelected;
      this.contrat.echeancier.forEach((el) => {
        if (el.selected !== undefined && (!el.etat || this.isModifiable(el.etat))) {
          el.selected = select;
        }
      });
    },
    updateEcheancier(newListEcheance) {
      const loadingComponent = this.$buefy.loading.open();
      newListEcheance.forEach((newEcheance) => {
        newEcheance.finPeriode = new Date(newEcheance.finPeriode);
        newEcheance.debutPeriode = new Date(newEcheance.debutPeriode);
        newEcheance.dateEcheance = new Date(newEcheance.dateEcheance);
        newEcheance.factures = [];
        newEcheance.key = genererGuid();
        newEcheance.selected = false;
        newEcheance.listeProduits = [];
        if (!newEcheance.tiers) {
          newEcheance.tiers = { nomCommercial: newEcheance.tiersId.toString() };
        }
        this.contrat.echeancier.push(newEcheance);
      });
      this.bailleurList = cloneDeep(this.getBailleur);
      sortEcheance(this.contrat.echeancier, this.sort);
      this.afficherEcheancier = true;
      loadingComponent.close();
    },
    getAllEcheanceSelected() {
      return this.contrat.echeancier.filter((echeance) => {
        return echeance.selected && (!echeance.etat || this.isModifiable(echeance.etat));
      });
    },
    openPopUpAjoutEcheancierManuel() {
      if (this.bailleurList.length > 1) this.popUpAddEcheancierManuel = true;
      else this.addEcheancierManuel(this.bailleurList[0].tiersId);
    },
    addEcheancierManuel(tiersId) {
      const bailleurSelected = this.contrat.intervenants.find((inter) => {
        return inter.tiersId === tiersId;
      });
      if (!bailleurSelected) return;
      const echeancierGenerer = genererEcheancierManuelContrat(bailleurSelected);
      echeancierGenerer.pourcentageTva = this.echeancier.pourcentageTva;
      echeancierGenerer.listeProduits = this.contrat.contratsProduits;
      if (this.produitAchatLocDefault) {
        echeancierGenerer.listeProduitsLocationEtDivers = [{
          produitId: this.produitAchatLocDefault.id,
          libelle: this.produitAchatLocDefault.libelle,
          typeProduit: this.produitAchatLocDefault.supportCommercial?.categorieVente,
        }];
      }
      this.contrat.echeancier.push(echeancierGenerer);
      this.bailleurList = cloneDeep(this.getBailleur);
      sortEcheance(this.contrat.echeancier, this.sort);
      this.afficherEcheancier = true;
    },
    getMotifBlocageLibelle(motifBlocageId) {
      if (!motifBlocageId) return '';
      const motif = this.motifsBlocage
        .find((m) => m.id === motifBlocageId);
      return motif?.libelle || '';
    },
    secondDropdownItems(ligne) {
      const actions = [];
      if (!ligne.etat) {
        actions.push({
          action: () => this.deleteEcheance(ligne.key),
          libelle: this.$t('ajoutEditContrat.echeancier.tabEcheance.actions.supprimer'),
          id: 1,
        });
      } else if (this.isModifiable(ligne.etat)) {
        actions.push(
          {
            action: () => this.addTiers(ligne.key),
            libelle: this.$t('ajoutEditContrat.echeancier.tabEcheance.actions.addTiers'),
            id: 0,
          },
          {
            action: () => this.deleteEcheance(ligne.key),
            libelle: this.$t('ajoutEditContrat.echeancier.tabEcheance.actions.supprimer'),
            id: 1,
          },
        );
      }
      actions.push({
        action: () => this.editCommentaire(ligne),
        libelle: this.$t('ajoutEditContrat.echeancier.tabEcheance.actions.editCommentaire'),
        id: 2,
      });
      actions.push({
        action: () => this.setDetailProduits(ligne),
        libelle: this.modulePresseActive ? this.$t('ajoutEditContrat.echeancier.tabEcheance.produit')
          : this.$t('ajoutEditContrat.echeancier.tabEcheance.faceEcran'),
        id: 3,
      });
      return actions;
    },
    getProduitLocationEtDiversLibelle(ligne) {
      return ligne.listeProduitsLocationEtDivers.length > 1
        ? this.$t('ajoutEditContrat.echeancier.tabEcheance.multiProduit')
        : (ligne.listeProduitsLocationEtDivers[0]?.libelle ?? '');
    },
    async initializeProduitAchat() {
      const queryItemLocationAchat = {
        query: {
          societeId: this.societeActiveId,
          actif: null,
          sens: SENS_ACHAT,
        },
        maxResultCount: NO_PAGINATION,
        sens: SENS_ACHAT,
      };
      const produitsLocationAchat = (await getAllLocation(queryItemLocationAchat))
        .data.result.items;
      const queryItemDiversAchat = {
        query: {
          societeId: this.societeActiveId,
          sens: SENS_ACHAT,
          actif: null,
        },
        maxResultCount: NO_PAGINATION,
      };
      const produitsDiversAchat = (await getAllDivers(queryItemDiversAchat)).data.result.items;
      this.allProduitsAchat = produitsLocationAchat.concat(produitsDiversAchat);
      this.produitsAchat = this.allProduitsAchat;
      this.produitAchatLocDefault = produitsLocationAchat.find(p => {
        return p.id === this.societeActive.produitIdDefautLoyer;
      });
    },
    setProduitAchat(produit, ligne) {
      if (!produit) return;
      ligne.listeProduitsLocationEtDivers = [{
        produitId: produit.id,
        libelle: produit.libelle,
        typeProduit: produit.supportCommercial?.categorieVente,
      }];
      ligne.produitAchatId = produit.id;
    },
    getProduitAchat(text) {
      if (!text.trim()) {
        this.produitsAchat = this.allProduitsAchat;
        return;
      }
      this.produitsAchat = this.allProduitsAchat.filter(p => p.libelle
        .toLowerCase().includes(text.toLowerCase()));
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      societeActive: 'societeActive',
    }),
    modulePresseActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePresse.key);
    },
    getEcheanceIndexeeModifiees() {
      const changes = [];
      this.contrat.echeancier.forEach(e => {
        const sameEch = this.lockEcheancier.find(lockEch => isEqual(lockEch, e));
        if (!sameEch && e.montantIndexationReference) changes.push(e);
      });
      return changes;
    },
    getListeEcheanceOutsideRange() {
      const messages = [];
      this.contrat.echeancier.forEach((echeance) => {
        if (moment(echeance.dateEcheance).isBefore(moment(this.contrat.dateDebutEcheance))
          || moment(echeance.dateEcheance).isAfter(moment(this.contrat.dateFinEcheance))) {
          messages.push({
            isLink: false,
            libelle: this.$t('ajoutEditContrat.echeancier.info.echeanceOutsidePeriode', {
              dateEcheance: formatDate(echeance.dateEcheance),
              tiers: echeance.tiers.nomCommercial,
              montantEcheance: echeance.montantHt,
              debutBail: formatDate(this.contrat.dateDebutEcheance),
              finBail: formatDate(this.contrat.dateFinEcheance),
            }),
          });
        }
      });
      return messages;
    },
    getListeMessageBlocage() {
      const messages = [];
      this.contrat.intervenants.filter(i => i.tiers?.blocageReglement).forEach((i) => {
        const motifLibelle = this.getMotifBlocageLibelle(i.tiers?.motifBlocageId);
        messages.push({
          isLink: false,
          libelle: this.$t('ajoutEditContrat.echeancier.info.bailleurBlocageReglement', {
            motif: motifLibelle || this.$t('ajoutEditContrat.echeancier.info.aucunMotifBlocage'),
            nom: i.tiers?.nomCommercial,
          }),
        });
      });
      return messages;
    },
    allEcheanceSelected() {
      return this.getAllEcheanceSelected().length === this.contrat.echeancier.filter((echeance) => {
        return !echeance.etat || this.isModifiable(echeance.etat);
      }).length
        && this.contrat.echeancier.filter((echeance) => {
          return !echeance.etat || this.isModifiable(echeance.etat);
        }).length > 0;
    },
    iconSelectTotal() {
      if (this.allEcheanceSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    canGenerate() {
      return this.contrat.intervenants.filter((intervenant) => {
        return intervenant.tiers;
      }).length > 0
      && this.contrat.contratsMateriels.length > 0;
    },
    modesReglement() {
      const modesReglement = this.parametre(PARAMETRES_KEYS.modeReglement);
      return modesReglement.filter((modeReglement) => {
        return modeReglement.actionAchat !== AUCUN;
      });
    },
    motifsBlocage() {
      return this.parametre(PARAMETRES_KEYS.motifBlocage);
    },
    hasMultipleBailleurInList() {
      return this.bailleurList.filter((bailleur) => {
        return bailleur.mustAppearInEcheanceList;
      }).length;
    },
    getHeightestDateFin() {
      if (this.contrat.echeancier.length === 0) return this.getDate(this.contrat.dateFinEcheance);
      let maxDateFin = this.contrat.echeancier[0].finPeriode;
      this.contrat.echeancier.forEach((echeance) => {
        if (moment(echeance.finPeriode) > moment(maxDateFin)) {
          maxDateFin = echeance.finPeriode;
        }
      });
      return this.getDate(maxDateFin);
    },
    getBailleur() {
      let bailleurList = this.contrat.intervenants.filter((int) => { return int.tiersId; })
        .map((intervenant) => {
          return { libelle: intervenant.tiers.nomCommercial, tiersId: intervenant.tiersId };
        });
      bailleurList = bailleurList.concat(this.contrat.echeancier
        .map((echeance) => {
          return { libelle: echeance.tiers.nomCommercial, tiersId: echeance.tiersId };
        }));
      const finalList = [];
      [...new Set(bailleurList.map((bailleur) => bailleur.tiersId))].forEach((tiersId) => {
        finalList.push({
          tiersId: tiersId,
          mustAppearInEcheanceList: true,
          libelle: bailleurList.find((bail) => { return bail.tiersId === tiersId; }).libelle,
        });
      });
      return finalList.sort((a, b) => {
        return a.libelle.localeCompare(b.libelle);
      });
    },
    getSmallestDateDebut() {
      if (this.contrat.echeancier.length === 0) return this.getDate(this.contrat.dateDebutEcheance);
      let minDateDebut = this.contrat.echeancier[0].debutPeriode;
      this.contrat.echeancier.forEach((echeance) => {
        if (moment(echeance.debutPeriode) < moment(minDateDebut)) {
          minDateDebut = echeance.debutPeriode;
        }
      });
      return this.getDate(minDateDebut);
    },
    regimesTva() {
      return this.parametre(PARAMETRES_KEYS.regimeTva).filter((tva) => {
        return tva.actif;
      });
    },
    firstDropdownItems() {
      return [{
        action: () => this.openPopUpAjoutEcheancierManuel(),
        libelle: this.$t('ajoutEditContrat.echeancier.ajoutEcheancierManuel'),
        id: 0,
      }];
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.contrat.echeancier.length > 0) this.afficherEcheancier = true;
      this.bailleurList = cloneDeep(this.getBailleur);
      await this.loadParametres([PARAMETRES_KEYS.modeReglement,
        PARAMETRES_KEYS.motifBlocage, PARAMETRES_KEYS.regimeTva,
      ]);
      await this.initializeProduitAchat();
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
